import _ from 'lodash';
import React, { ComponentType } from 'react';
import { TemplateGalleryCard } from '../../../types/index';
import { TemplateCardProps } from '../TemplateCard/TemplateCard';

export type TemplateListCardComponentProps = Pick<
  TemplateCardProps,
  'forceRender' | 'index' | 'template'
> & {
  isMobileView?: boolean;
  showFeatures?: boolean;
};

export type ITemplateListCardComponent =
  ComponentType<TemplateListCardComponentProps>;

export type Props = {
  templates?: TemplateGalleryCard[];
  isMobileView: boolean;
  SSRFlow?: boolean;
  CardComponent: ITemplateListCardComponent;
  LoadingState: ComponentType<{ isMobileView?: boolean }>;
  showFeatures?: boolean;
};

const TemplateCardListItems = ({
  templates,
  isMobileView,
  SSRFlow,
  CardComponent,
  LoadingState,
  showFeatures,
}: Props) => {
  const haveTemplates = _.size(templates) > 0;

  if (haveTemplates) {
    return (
      <>
        {_.map(templates, (template, index) => (
          <li key={template.id}>
            <CardComponent
              isMobileView={isMobileView}
              template={template}
              forceRender={SSRFlow}
              index={index}
              showFeatures={showFeatures}
            />
          </li>
        ))}
      </>
    );
  }

  return <LoadingState isMobileView={isMobileView} />;
};

export default TemplateCardListItems;
